import { DIVERGENCE_FIELD  } from "./omega-node";
import { LUMINARY_CODE   } from "./matrix-payload";
import { AETHER_TIDE  } from "./delta-flux";


function decode(arr:number[]):string{
  return arr.map(x => String.fromCharCode(x)).join('');
}

export function yohainous(){
  return {
    nebulaFlux: decode(DIVERGENCE_FIELD),
    quantumSeed: decode(LUMINARY_CODE),
    hyperVector: decode(AETHER_TIDE)
  };
}